import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { MAP_MODES } from '../../../store/map/map.constants'
import { selectMapMode } from '../../../store/map/map.selectors'
import { withOnlyGE } from '../../Device'
import T from '../../i18n/T'
import { ONE_MINUTE_MS, pad } from '../../utils/date'
import s from './TrafficLegend.less'

export const formatHourFromDate = date => {
  const mins = date.getMinutes()
  const hours = date.getHours()
  return pad(hours) + ':' + pad(mins)
}

const TrafficLegend = withOnlyGE(() => {
  const mapMode = useSelector(selectMapMode).mode
  const intervalRef = useRef()
  const [lastUpdate, setLastUpdate] = useState(new Date())

  useEffect(() => {
    if (mapMode === MAP_MODES.traffic) {
      intervalRef.current = setInterval(() => {
        setLastUpdate(new Date())
      }, 2 * ONE_MINUTE_MS)
    } else {
      clearInterval(intervalRef.current)
    }
    return () => {
      clearInterval(intervalRef.current)
    }
  }, [mapMode])

  if (mapMode !== MAP_MODES.traffic) return <></>

  return (
    <div className={s.trafficLegend}>
      <p className={s.title}>
        <T id={'map.tools.layers.traffic.legend'} />
        &nbsp;
        {formatHourFromDate(lastUpdate)}
      </p>
      <ul>
        <li className={s.yellow} />
        <li className={s.orange} />
        <li className={s.red} />
        <li className={s.darkred} />
        <li className={s.black} />
      </ul>
      <p>
        <span className={s.left}>
          <T id={'map.tools.layers.traffic.slow'} />
        </span>
        <span className={s.right}>
          <T id={'map.tools.layers.traffic.congested'} />
        </span>
      </p>
    </div>
  )
})

export default TrafficLegend
